import Dexie from 'dexie';

class InfoDb {
    constructor() {
        this.db = new Dexie('ro-info');
        this.db.version(1).stores({
            dbUpdates:   '++id, dbName',
            appSettings: 'name',
        });
    }

    async getAppSettings() {
        let rows       = await this.db.appSettings.toArray();
        let settings = {};
        rows.map(row => {
            settings[row.name] = row.value;
        });
        return settings;
    }

    async setAppSettings(settings) {
        let keys = Object.keys(settings);
        for (let i = 0; i < keys.length; i++) {
            let settingName = keys[i];
            let setting = await this.db.appSettings.get({name: settingName});
            if (!setting) {
                this.db.appSettings.add({name: settingName, value: settings[settingName]});
            } else {
                this.db.appSettings.put({name: settingName, value: settings[settingName]});
            }
        }
    }

    async getSyncedTableNames() {
        let rows       = await this.db.dbUpdates.toArray();
        let tableNames = [];
        rows.map(rows, row => {
            tableNames.push(row.dbname);
        });
        return tableNames;
    }

    async setLatestUpdateDate(dbName, updatedAt) {
        let info = await this.db.dbUpdates.get({dbName: dbName});
        if (!info) {
            return this.db.dbUpdates.add({dbName: dbName, updatedAt: updatedAt});
        }
        return this.db.dbUpdates.put({id: info.id, dbName: dbName, updatedAt: updatedAt});
    }

    async getLatestUpdateDate(dbName) {
        await this.db.open();
        let info = await this.db.dbUpdates.get({dbName: dbName});
        if (info) {
            return info.updatedAt;
        }
        return null;
    }

}

export default new InfoDb();


// WEBPACK FOOTER //
// ./src/database/infoDb.js